import { HtmlLike } from "@common/controls/component";
import HelpIcon from "@common/controls/Icon/Help/component";
import { type InputTypeProps } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";
import "./style.less";

export type OnOffProps = InputTypeProps<boolean> & {
  label?: string;
  onText?: string;
  offText?: string;
  title?: string;
  tooltip?: string;
};
const OnOff = (props: OnOffProps) => {
  const i18n = useI18n();
  return (
    <div className="on_off">
      {props.label && (
        <div className={classNames("on_off_label")}>
          <HtmlLike tag="span">{props.label}</HtmlLike>
          {props.tooltip && <HelpIcon tooltip={props.tooltip} />}
        </div>
      )}
      <div
        className={classNames("on_off_toggle", { disabled: props.isDisabled, on: props.value }, props.className)}
        data-name={props.qa || props.name}
        onClick={props.isDisabled ? undefined : () => props.onChange(!props.value)}
      >
        <div className="knobs">
          {(props.title ?? (props.value ? props.onText ?? i18n.on : props.offText ?? i18n.off)).toUpperCase()}
        </div>
      </div>
    </div>
  );
};
export default OnOff;
